import React, { Component, useEffect, useState, useRef } from 'react';
import MenuIcon from '@material-ui/icons/Menu';
import CloseIcon from '@material-ui/icons/Close';
import './style.css'

const Header=()=>{

    const [isOpen,setIsOpen]=useState(false)
    const [navbar,setNavbar]=useState(false)
    const [classnav,setclassnav]=useState('nav-link')

    useEffect(()=>{
        document.addEventListener('scroll',()=>{
            getYAxis()
        })

        // return ()=>{
        //     document.removeEventListener('scroll')
        // }
    },[])
    
    const getYAxis=()=>{     
        let navItem = document.querySelectorAll(".nav-link")
        console.log(window.pageYOffset)
        if(window.scrollY > 2500) {
            for(let i=0;i<navItem.length;i++){
                navItem[i].classList.remove('nav-active')
            }
            navItem[3].classList.add('nav-active')
        } else if (window.scrollY > 1700){
            for(let i=0;i<navItem.length;i++){
                navItem[i].classList.remove('nav-active')
            }
            navItem[2].classList.add('nav-active')
        } else if (window.scrollY > 600){
            for(let i=0;i<navItem.length;i++){
                navItem[i].classList.remove('nav-active')
            }
            navItem[1].classList.add('nav-active')
        } else if (window.scrollY < 600){
            for(let i=0;i<navItem.length;i++){
                navItem[i].classList.remove('nav-active')
            }
            // navItem[0].classList.add('nav-active')
        }
    }
    
    // getYAxis()

    const changeBackground=()=>{
        if(window.scrollY >= 100){
            setNavbar(true)
        } else {
            setNavbar(false)
        }
    }

    const toSection=(section)=>{
        if(section==="home"){
            document.getElementById(section).scrollIntoView({ behavior: 'smooth' })
        } else {
            let element = document.getElementById(section)
            element.scrollIntoView(true)
            let heightHeader = 80
            let scrolledY = window.scrollY
            if(scrolledY){
                window.scrollTo({
                    behavior:'smooth',
                    top:scrolledY - heightHeader
                })
            }
        }
        setIsOpen(false)
    }

    window.addEventListener('scroll',changeBackground)

    return(
        <section className={navbar?'header actived':'header'}>
            <div className='header-logo'>
                <a>GetUp!Edutainment</a>
            </div>
            <div className={isOpen?"navigation show":"navigation"}>
                <ul className='nav-list'>
                    <li className='nav-item'>
                        <a onClick={()=>toSection('home')} className={'nav-link'}>Home</a>
                    </li>
                    <li className='nav-item'>
                        <a onClick={()=>toSection('about')} className='nav-link'>About</a>
                    </li>
                    <li className='nav-item'>
                        <a onClick={()=>toSection('activities')} className='nav-link'>Activities</a>
                    </li>
                    <li className='nav-item'>
                        <a onClick={()=>toSection('contact')} className='nav-link'>Contact</a>
                    </li>
                </ul>
            </div>
            <div className='toggle-nav'>
                {
                    isOpen?
                    <CloseIcon onClick={()=>setIsOpen(false)} />
                    :
                    <MenuIcon onClick={()=>setIsOpen(true)} />
                }
            </div>
        </section>
    )
}

export default Header